class SideBySideTabs extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.triggers = [...this.querySelectorAll('[data-tab-trigger]')];
    this.items = [...this.querySelectorAll('[data-tab-content]')];
    this.tabsList = this.querySelector('[data-tabs-list]');
    this.prevArrow = this.querySelector('[data-arrow-prev]');
    this.nextArrow = this.querySelector('[data-arrow-next]');

    if (this.triggers.length === 0 || this.items.length === 0) return;

    const activeTrigger = this.triggers.find((t) => t.classList.contains('active')) || this.triggers[0];
    const initialId = activeTrigger.dataset.tabTarget;

    this.activateTab(initialId);
    this.checkOverflow();

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-tab-trigger]');
      if (trigger) {
        const id = trigger.dataset.tabTarget;
        if (id) this.activateTab(id, true);
      }

      const prevBtn = event.target.closest('[data-arrow-prev]');
      if (prevBtn) {
        this.tabsList.scrollBy({ left: -200, behavior: 'smooth' });
      }

      const nextBtn = event.target.closest('[data-arrow-next]');
      if (nextBtn) {
        this.tabsList.scrollBy({ left: 200, behavior: 'smooth' });
      }
    });

    if (this.tabsList) {
      this.tabsList.addEventListener('scroll', () => this.updateArrows());
      window.addEventListener('resize', () => this.checkOverflow());
      setTimeout(() => this.checkOverflow(), 100);
    }

    document.addEventListener('shopify:block:select', (e) => {
      if (this.contains(e.target)) {
        const blockId = e.detail.blockId;
        if (blockId) this.activateTab(blockId, true);
      }
    });
  }

  checkOverflow() {
    if (!this.tabsList || !this.prevArrow || !this.nextArrow) return;

    const isOverflowing = this.tabsList.scrollWidth > this.tabsList.clientWidth;

    this.classList.toggle('is-overflowing', isOverflowing);

    if (!isOverflowing) {
      this.prevArrow.disabled = true;
      this.nextArrow.disabled = true;
    } else {
      this.updateArrows();
    }
  }

  updateArrows() {
    if (!this.tabsList || !this.prevArrow || !this.nextArrow) return;

    const tolerance = 2;
    const scrollLeft = this.tabsList.scrollLeft;
    const maxScroll = this.tabsList.scrollWidth - this.tabsList.clientWidth;

    this.prevArrow.disabled = scrollLeft <= tolerance;
    this.nextArrow.disabled = scrollLeft >= maxScroll - tolerance;
  }

  activateTab(id, shouldScroll = false) {
    const targetTrigger = this.querySelector(`[data-tab-target="${id}"]`);
    const targetItem = this.querySelector(`[data-tab-content="${id}"]`);

    if (!targetTrigger || !targetItem) return;

    this.triggers.forEach((trigger) => trigger.classList.remove('active'));
    this.items.forEach((item) => item.classList.remove('active'));

    targetTrigger.classList.add('active');
    targetItem.classList.add('active');

    if (shouldScroll) {
      targetTrigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }
}

if (!customElements.get('side-by-side-tabs')) {
  customElements.define('side-by-side-tabs', SideBySideTabs);
}